import { render, staticRenderFns } from "./champagne.vue?vue&type=template&id=03ecf5c8&scoped=true"
import script from "./champagne.vue?vue&type=script&lang=js"
export * from "./champagne.vue?vue&type=script&lang=js"
import style0 from "./champagne.vue?vue&type=style&index=0&id=03ecf5c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ecf5c8",
  null
  
)

export default component.exports